import { mapState, mapMutations } from 'vuex';
import mixin from '../mixin/controlMixin';
import controlAction from './controlAction.vue';
export default {
  mixins: [mixin],
  components: {
    controlAction
  },
  props: {
    groupItem: {
      type: Object,
      default: () => null
    },
    index: {
      type: Number,
      default: 0
    },
    formIdx: {
      type: Number,
      default: 0
    },
    itemid: {
      type: Number,
      default: null
    },
    isCheck: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    item() {
      return this.groupItem;
    },
    ...mapState({
      formDataArray: state => state.control.formDataArray,
      groupSelected: state => state.control.groupSelected,
      activeIdx: state => state.control.activeIdx
    })
  },
  data() {
    return {
      isSelected: -1,
      formeFalse1: false,
      MinMaxindex: 0 //每个点击项的索引值作为全局使用
    };
  },
  methods: {
    // 鼠标悬浮事件
    // highlight(index) {
    //   this.item[index].isHighlighted = true;
    // },
    // // 鼠标移除的事件监听
    // removeHighlight(index) {
    //   this.item[index].isHighlighted = false;
    // },
    // 点击显示  下拉、上移、编辑按钮
    // toggleSelection(index, item) {
    //   console.log('111111-----', this.group);
    //   const auditFlowId = this.itemid; //审核流id
    //   const nodeId = index; //选中index
    //   const controlIndexPadded = '0000'; //节点id
    //   const controlId = `d.${auditFlowId}control${controlIndexPadded}${nodeId}`;
    //   item.mark = controlId;
    //   this.isSelected = index;
    //   item.isSelectedShow = true;
    //   // 显示 下拉、上移、编辑按钮
    //   item.isSelected = true;
    //   item.isCheck = true
    //   console.log('6666----');
    //   this.$emit('updateFormDataArray', index);
    //   //   this.$parent.updateFormDataArray();
    // },
    // canMoveUp(index) {
    //   return index > 0;
    // },
    // canMoveDown(index) {
    //   return index < this.formDataArray[this.formIdx].groupFormData[index].length - 1;
    // },
    // moveUp(index) {
    //   if (index > 0) {
    //     const temp = this.item;
    //     this.$set(this.formDataArray, index, this.formDataArray[index - 1]);
    //     this.$set(this.formDataArray, index - 1, temp);
    //   }
    // },
    // moveDown(index) {
    //   if (index < this.formDataArray[this.formIdx].groupFormData[index].length - 1) {
    //     // 判断是否有关联
    //     if (this.isHaveRelation) {
    //       const that = this;
    //       this.$confirm({
    //         title: this.$t('移动控件位置将清除所有控件间的关联关系，是否继续执行？'),
    //         onOk() {
    //           // 清除关联
    //           that.clearRelationData();
    //           const temp = that.item;
    //           that.$set(that.formDataArray, index, that.formDataArray[index + 1]);
    //           that.$set(that.formDataArray, index + 1, temp);
    //         }
    //       });
    //     } else {
    //       const temp = this.item;
    //       this.$set(this.formDataArray, index, this.formDataArray[index + 1]);
    //       this.$set(this.formDataArray, index + 1, temp);
    //     }
    //   }
    // },
    // // 编辑按钮--打开内容输入内容
    // formeClick(index, type) {
    //   //   console.log('编辑点击事件', this.item, this.formeFalse1);
    //   this.formeFalse1 = !this.formeFalse1;
    //   // this.$set(this.item,'editing',!this.item.editing)
    //   this.item.editing = !this.item.editing;
    // },
    // // 关闭事件
    // formeClase(index) {
    //   this.item.editing = false;
    // },
    // //  复制
    // copyControl(index) {
    //   // this.itemid获取id
    //   // 假设审核流id为123，节点id为456，时间戳为1630218456789，控件序号为1
    //   const auditFlowId = this.itemid; //审核流id
    //   const nodeId = index; //选中index
    //   const controlIndexPadded = '0000'; //节点id
    //   //  const controlId = `d.${auditFlowId}${nodeId}control${}${controlIndexPadded}`;
    //   const controlId = `d.${auditFlowId}control${controlIndexPadded}${nodeId}`;
    //   this.item.mark = controlId;
    //   const msg = this.item.mark;
    //   const save = function (e) {
    //     e.clipboardData.setData('text/plain', msg);
    //     e.preventDefault(); // 阻止默认行为
    //   };
    //   const once = {
    //     once: true
    //   };
    //   document.addEventListener('copy', save, once); // 添加一个copy事件,当触发时执行一次,执行完删除
    //   document.execCommand('copy'); // 执行copy方法
    //   this.$message.success(this.$t('复制成功'));
    // },
    // // 编辑显示弹框--校验
    // // 单行文本 小数点位数 没有输入内容 并且失去焦点 将数据设置为默认状态
    // xsdDefault1(index) {
    //   if (!this.item.decimalPlaces) {
    //     this.item.decimalPlaces = 2;
    //   }
    // },
    // minMaxNav(index) {
    //   this.MinMaxindex = index;
    // },
    // // 单行文本 没有输入内容 并且失去焦点 将数据设置为默认状态
    // zsxzDefault1(index) {
    //   if (!this.item.textMinLength) {
    //     this.item.textMinLength = 0;
    //   }
    // },
    // zsxzDefault2(index) {
    //   if (!this.item.textMaxLength) {
    //     this.item.textMaxLength = 200;
    //   }
    // },
    // //数值限制 最小 默认值
    // szxzNumberMIN(index) {
    //   if (!this.item.numberMinValue) {
    //     this.item.numberMinValue = 0;
    //   }
    // },
    // //数值限制 最大  默认值
    // szxzNumberMAX(index) {
    //   if (!this.item.numberMaxValue) {
    //     this.item.numberMaxValue = 40000000;
    //   }
    // }
  }
};